import { LOANS } from 'loans.module/common/domain/constants.loans';

import agreementHousingLoan from './static/agreementHousingLoan';
import fiveMonth from './static/fiveMonth';
import nineMonth from './static/nineMonth';
import socialHousingLoan from './static/socialHousingLoan';
import variousCredit from './static/variousCredit';
import diversalAtention from './static/diversalAtention';
import dataTable from './static/dataBasicCharacteristicsTable';

export default class LoansStaticService {
  constructor($http) {
    'ngInject';
    this.http = $http;
    this.loans = {};
    this.tableBasicCharacteristics = dataTable;
    this.initLoansWithId();
    this.initLoansWithIdHR();
  }

  initLoansWithId() {
    this.loans[LOANS.ID.FIVE_MONTH] = fiveMonth;
    this.loans[LOANS.ID.NINE_MONTH] = nineMonth;
    this.loans[LOANS.ID.SOCIAL_HOUSING_LOAN] = socialHousingLoan;
    this.loans[LOANS.ID.AGREEMENT_HOUSING_LOAN] = agreementHousingLoan;
    this.loans[LOANS.ID.VARIOUS_CREDIT] = variousCredit;
    this.loans[LOANS.ID.DIVERSAL_ATENTION] = diversalAtention;
  }

  initLoansWithIdHR() {
    this.loans[LOANS.ID_HR.FIVE_MONTH] = fiveMonth;
    this.loans[LOANS.ID_HR.NINE_MONTH] = nineMonth;
    this.loans[LOANS.ID_HR.SOCIAL_HOUSING_LOAN] = socialHousingLoan;
    this.loans[LOANS.ID_HR.AGREEMENT_HOUSING_LOAN] = agreementHousingLoan;
    this.loans[LOANS.ID_HR.VARIOUS_CREDIT] = variousCredit;
    this.loans[LOANS.ID_HR.DIVERSAL_ATENTION] = diversalAtention;
  }

  getAll() {
    return this.loans;
  }

  get(loanId) {
    return this.loans[loanId];
  }

  getDataTableBasicCharacteristics() {
    return this.tableBasicCharacteristics;
  }
}



// WEBPACK FOOTER //
// ./client/app/loans.module/common/services/loansStatic.service.js